import { createSlice } from '@reduxjs/toolkit';

import { quickFilter, toggleButtonGroupValues } from './constants';

const initialState = {
	toggleValue: toggleButtonGroupValues.MY_TEAM,
	myTeam: [],
	selectedSeller: null,
	leadsSummary: {},
	infoGraphicsData: {
		tasks: {},
		contacts: {},
		production: {},
	},
	bruttoProductionTeamActivities: [],
	bruttoPeriodQuickFilter: quickFilter.TODAY_MINUS_TWO_DAYS,
};

export const dashboardStatistics = createSlice({
	name: 'dashboard-statistics',
	initialState,
	reducers: {
		setToggleValue: (state, { payload }) => ({
			...state,
			toggleValue: payload,
		}),
		setMyTeam: (state, { payload }) => ({
			...state,
			myTeam: payload,
		}),
		appendMyTeam: (state, { payload }) => ({
			...state,
			myTeam: [...state.myTeam, ...payload],
		}),
		setBruttoProductionTeamActivities: (state, { payload }) => ({
			...state,
			bruttoProductionTeamActivities: payload,
		}),
		appendBruttoProductionTeamActivities: (state, { payload }) => ({
			...state,
			bruttoProductionTeamActivities: [...state.bruttoProductionTeamActivities, ...payload],
		}),
		setSelectedSeller: (state, { payload }) => ({
			...state,
			selectedSeller: payload,
		}),
		setLeadsSummary: (state, { payload }) => ({
			...state,
			leadsSummary: payload,
		}),
		setInfoGraphicsData: (state, { payload }) => ({
			...state,
			infoGraphicsData: {
				...state.infoGraphicsData,
				...payload,
			},
		}),
		setBruttoPeriodQuickFilter: (state, { payload }) => ({
			...state,
			bruttoPeriodQuickFilter: payload,
		}),
		reset: () => initialState,
	},
});

export default dashboardStatistics.reducer;
export const REDUCER_NAME = dashboardStatistics.name;

export const {
	setToggleValue,
	setMyTeam,
	appendMyTeam,
	setBruttoProductionTeamActivities,
	appendBruttoProductionTeamActivities,
	setSelectedSeller,
	setInfoGraphicsData,
	setLeadsSummary,
	setBruttoPeriodQuickFilter,
	reset,
} = dashboardStatistics.actions;
